"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencySymbol = 'Ꞩ';
exports.FeeQuantPlanck = 1000000;
exports.OneSignaPlanck = 100000000;
//# sourceMappingURL=constants.js.map